
import { Vue, Prop, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import BarcodeOrderModule from "@/store/modules/barcodeSystem/barcodeOrder";
import { BarcodeOrderItemPickListItem } from "@/models/api/barcodeSystem/barcodeOrders/get";

const barcodeOrderModuleState = getModule(BarcodeOrderModule);

@Component
export default class BarcodeOrderItemPickTable extends Vue {
[x: string]: any;
  @Prop({ default: false })
  loading: boolean;


  get barcodeOrderItemPicks(): Array<BarcodeOrderItemPickListItem> {
    return barcodeOrderModuleState.currentBarcodeOrderItemPicks;
  }

  get selectedItemCount(): number {
    return barcodeOrderModuleState.getSelectedBarcodeOrderItemPickCount;
  }

  get selectedItems(): Array<any> {
    return barcodeOrderModuleState.getSelectedBarcodeOrderItemPicks;
  }

  get totalItems() {
    if (barcodeOrderModuleState.currentBarcodeOrderItemPicks) {
      return barcodeOrderModuleState.currentBarcodeOrderItemPicks.length
    } else {
      return 0;
    }
  }

  onDoubleClicked(data) {
    this.updateItemPrompt(data);
  }

  onRowClick(data) {
    this.unselectAll();
    barcodeOrderModuleState.switchBarcodeOrderItemPickSelectionStatus(data.id);
  }

  unselectAll() {
    let items = this.selectedItems;

    items.forEach(item => {
      barcodeOrderModuleState.switchBarcodeOrderItemPickSelectionStatus(item.id);
    });
  }
}
